import { CategoryData } from '../../../../types/types';

export const famille: CategoryData = {
    // Parents directs

      'Bangebaaw (Parents)': { translation: 'Parents', translationEn: 'Parents', illustration: '👨👩', audio: 'Ba-bangebaaw' },
    'Bamuso (Mère)': { translation: 'Mère', translationEn: 'Mother', illustration: '👩', audio: 'Ba-bamuso' },
    'Face (Père)': { translation: 'Père', translationEn: 'Father', illustration: '👨', audio: 'Ba-face' },
    'Baa (Mère)': { translation: 'Maman', translationEn: 'Mom', illustration: '👩', audio: 'Ba-baa' },
    'Faa (Père)': { translation: 'Papa', translationEn: 'Dad', illustration: '👨', audio: 'Ba-faa' },

    // Grands-parents
    'Mamamuso (Grand-mère)': { translation: 'Grand-mère', translationEn: 'Grandmother', illustration: '👵', audio: 'Ba-mamamuso' },
    'Mamacɛ (Grand-père)': { translation: 'Grand-père', translationEn: 'Grandfather', illustration: '👴', audio: 'Ba-mamace' },

     'Sanjida (Age)': { translation: 'Age', translationEn: 'Age', illustration: '👴', audio: 'Ba-sanjida' },

    // Enfants
    'Dencɛ (Fils)': { translation: 'Fils', translationEn: 'Son', illustration: '👦', audio: 'Ba-dence' },
    'Denmuso (Fille)': { translation: 'Fille', translationEn: 'Daughter', illustration: '👧', audio: 'Ba-denmuso' },
    'Mamaden (Petit-fils/Petite-fille)': { translation: 'Petit-fils/Petite-fille', translationEn: 'Grandson/Granddaughter', illustration: '👶', audio: 'Ba-mamaden' },

    // Oncles et tantes
    'Tɛnɛmuso (Tante)': { translation: 'Tante - sœur du père', translationEn: 'Aunt - father\'s sister', illustration: '👩', audio: 'Ba-tenemuso' },
    'Belencɛ (Oncle maternel)': { translation: 'Oncle maternel', translationEn: 'Maternal uncle', illustration: '👨', audio: 'Ba-belence' },
    'Facɛfitinin (Oncle paternel cadet)': { translation: 'Oncle paternel cadet', translationEn: 'Younger paternal uncle', illustration: '👨', audio: 'Ba-facefitinin' },
    'Facɛkɔrɔba (Oncle paternel aîné)': { translation: 'Oncle paternel aîné', translationEn: 'Elder paternal uncle', illustration: '👨', audio: 'Ba-facekoroba' },
    'Bakɔrɔ (Sœur de la mère aînée)': { translation: 'Sœur de la mère aînée', translationEn: 'Mother\'s elder sister', illustration: '👩', audio: 'Ba-bakoro' },

    // Frères et sœurs
    'Kɔrɔmuso (Sœur aînée)': { translation: 'Sœur aînée', translationEn: 'Elder sister', illustration: '👧', audio: 'Ba-koromuso' },
    'Kɔrɔcɛ (Frère aîné)': { translation: 'Frère aîné', translationEn: 'Elder brother', illustration: '👦' },
    'Dɔgɔmuso (Sœur cadette)': { translation: 'Sœur cadette', translationEn: 'Younger sister', illustration: '👧' },
    'Dɔgɔcɛ (Frère cadet)': { translation: 'Frère cadet', translationEn: 'Younger brother', illustration: '👦', audio: 'Ba-dogoce' },

    // Cousins
    'Kanimɛ (Cousin/Cousine)': { translation: 'Cousin/Cousine', translationEn: 'Cousin', illustration: '👥', audio: 'Ba-kanime' },
    'Fafilamaden (Cousin germain par le père)': { translation: 'Cousin germain par le père', translationEn: 'First cousin on the father\'s side', illustration: '👦', audio: 'Ba-fafilamaden' },
    'Bafilamaden (Cousin germain par la mère)': { translation: 'Cousin germain par la mère', translationEn: 'First cousin on the mother\'s side', illustration: '👦', audio: 'Ba-bafilamaden' },

    // Alliance
    'Burancɛ (Beau-père/Beau-frère/Beau-fils)': { translation: 'Beau-père/Beau-frère/Beau-fils', translationEn: 'Father-in-law/Brother-in-law/Son-in-law', illustration: '👨', audio: 'Ba-burance' },
    'Buranmuso (Belle-mère/Belle-sœur/Belle-fille)': { translation: 'Belle-mère/Belle-sœur/Belle-fille', translationEn: 'Mother-in-law/Sister-in-law/Daughter-in-law', illustration: '👩', audio: 'Ba-buranmuso' },

    // Générations étendues
    'Tulomasama (Arrière petit-enfant/Grand-père)': { translation: 'Arrière petit-enfant/Grand-père', translationEn: 'Great-grandchild/Great-grandfather', illustration: '👴', audio: 'Ba-tulomasama' },
    'Bɛma (Ancêtre/Aïeul)': { translation: 'Ancêtre/Aïeul', translationEn: 'Ancestor/Forebear', illustration: '🌳', audio: 'Ba-bema' },
    'Bɔnsɔn (Descendant)': { translation: 'Descendant', translationEn: 'Descendant', illustration: '👶', audio: 'Ba-bonson' },
    'Filanin (Jumeau)': { translation: 'Jumeau', translationEn: 'Twin', illustration: '👯', audio: 'Ba-filanin' }
};

export default famille;
export {};
